import { render, staticRenderFns } from "./VStripe.vue?vue&type=template&id=8c125c26&scoped=true"
import script from "./VStripe.vue?vue&type=script&lang=js"
export * from "./VStripe.vue?vue&type=script&lang=js"
import style0 from "./VStripe.vue?vue&type=style&index=0&id=8c125c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c125c26",
  null
  
)

export default component.exports